import React from 'react';
import { Alert, Button, Popconfirm } from 'antd';
import { SyncOutlined } from '@ant-design/icons';

/**
 * یادآوری به مدیر برای به‌روزرسانی دستیار هوشمند پس از تغییر دانش‌ها.
 * به‌روزرسانی خودکار نیست (هزینه GapGPT به ازای هر درخواست است)؛ با یک کلیک همه بخش‌ها در یک درخواست ارسال می‌شوند.
 */
const EmbeddingStatusNotice = ({ status, running = false, onRun }) => {
  if (!status) return null;

  if (!status.rag_ready) {
    return (
      <Alert
        type="warning"
        showIcon
        message="دستیار هوشمند فعال نیست. کلید API را در «تنظیمات دستیار» وارد کنید."
      />
    );
  }

  if (!status.needs_embedding) return null;

  const changed = (status.pending_parts || 0) + (status.removed_parts || 0);

  return (
    <Alert
      type="info"
      showIcon
      message={`${changed} تغییر جدید هنوز به دستیار اضافه نشده است.`}
      action={onRun && (
        <Popconfirm
          title="دستیار با آخرین تغییرات به‌روز شود؟"
          okText="به‌روزرسانی"
          cancelText="انصراف"
          onConfirm={onRun}
        >
          <Button type="primary" size="small" icon={<SyncOutlined />} loading={running}>
            به‌روزرسانی دستیار
          </Button>
        </Popconfirm>
      )}
    />
  );
};

export default EmbeddingStatusNotice;
